// React for Website

import React from "react";
//outsource
import { Form, InputNumber, Tag, Select } from "antd";

//components

const VoucherAmount = ({ form }) => {
  // -------------------------- VAR --------------------------
  const prices = [
    { value: 50, label: <Tag>$ 50</Tag> },
    { value: 100, label: <Tag>$ 100</Tag> },
    { value: 200, label: <Tag>$ 200</Tag> },
    { value: 500, label: <Tag>$ 500</Tag> },
    { value: 1000, label: <Tag>$ 1,000</Tag> },
  ];

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION ------------------------
  const onChange = (value) => {
    form.setFieldsValue({ amount: value });
  };

  const onSelect = (value) => {
    form.setFieldsValue({ amount: value });
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="amount"
      label="Amount"
      // initialValue={initValue}
      rules={[
        {
          required: true,
          message: "Please input amount",
        },
      ]}
    >
      <InputNumber
        style={{ width: "100%" }}
        min={50}
        prefix="$"
        addonBefore={
          <Select defaultValue={50} options={prices} onChange={onSelect} />
        }
        onChange={onChange}
      />
    </Form.Item>
  );
};

export default VoucherAmount;
